export const initialData = {
    users: [
      { 
        id: "1", 
        role: "Admin", 
        email: "admin@entnt.in", 
        password: "admin123",
        name: "Dr. Smith"
      },
      { 
        id: "2", 
        role: "Patient", 
        email: "john@entnt.in", 
        password: "patient123", 
        patientId: "p1",
        name: "John Doe"
      },
      { 
        id: "3", 
        role: "Patient", 
        email: "jane@entnt.in", 
        password: "patient123", 
        patientId: "p2",
        name: "Jane Smith"
      }
    ],
    patients: [
      {
        id: "p1",
        name: "John Doe",
        email: "john@entnt.in",
        dob: "1990-05-10",
        contact: "1234567890",
        address: "123 Main St, City",
        healthInfo: "No known allergies",
        emergencyContact: "9876543210",
        createdAt: "2024-01-15T10:00:00Z"
      },
      {
        id: "p2",
        name: "Jane Smith",
        email: "jane@entnt.in",
        dob: "1985-08-22",
        contact: "2345678901",
        address: "456 Oak Ave, City",
        healthInfo: "Allergic to penicillin",
        emergencyContact: "8765432109",
        createdAt: "2024-02-20T14:30:00Z"
      }
    ],
    appointments: [
      {
        id: "a1",
        patientId: "p1",
        title: "Regular Checkup",
        description: "Completed regular checkup",
        comments: "All clear, next appointment in 6 months",
        appointmentDate: "2025-06-01T10:00:00Z",
        status: "Completed",
        cost: 120,
        treatment: "Regular cleaning done",
        nextAppointment: "2025-12-01T10:00:00Z",
        files: [],
        createdAt: "2025-05-25T09:00:00Z"
      },
      {
        id: "a2",
        patientId: "p2",
        title: "Emergency Treatment",
        description: "Tooth extraction",
        comments: "Successful extraction, prescribed painkillers",
        appointmentDate: "2025-06-05T14:00:00Z",
        status: "Completed",
        cost: 250,
        treatment: "Tooth extraction completed",
        nextAppointment: "2025-07-15T14:00:00Z",
        files: [],
        createdAt: "2025-06-05T10:00:00Z"
      },
      {
        id: "a3",
        patientId: "p1",
        title: "Cavity Filling",
        description: "Fill cavity in upper right molar",
        comments: "Patient prefers composite filling",
        appointmentDate: "2025-07-10T14:00:00Z",
        status: "Scheduled",
        cost: 200,
        treatment: "",
        nextAppointment: "",
        files: [],
        createdAt: "2025-06-01T09:00:00Z"
      },
      {
        id: "a4",
        patientId: "p2",
        title: "Follow-up Check",
        description: "Post-extraction checkup",
        comments: "Routine follow-up",
        appointmentDate: "2025-07-15T09:00:00Z",
        status: "Scheduled",
        cost: 80,
        treatment: "",
        nextAppointment: "",
        files: [],
        createdAt: "2025-06-05T15:00:00Z"
      },
      {
        id: "a5",
        patientId: "p1",
        title: "Root Canal",
        description: "Root canal treatment for lower left molar",
        comments: "First session",
        appointmentDate: "2025-07-20T13:00:00Z",
        status: "Scheduled",
        cost: 800,
        treatment: "",
        nextAppointment: "",
        files: [],
        createdAt: "2025-06-06T11:00:00Z"
      },
      {
        id: "a6",
        patientId: "p2",
        title: "Teeth Whitening",
        description: "Professional teeth whitening session",
        comments: "First whitening session",
        appointmentDate: "2025-07-25T10:00:00Z",
        status: "Scheduled",
        cost: 350,
        treatment: "",
        nextAppointment: "",
        files: [],
        createdAt: "2025-06-06T12:00:00Z"
      },
      {
        id: "a7",
        patientId: "p1",
        title: "Crown Fitting",
        description: "Crown fitting post root canal",
        comments: "",
        appointmentDate: "2025-08-01T15:00:00Z",
        status: "Scheduled",
        cost: 1000,
        treatment: "",
        nextAppointment: "",
        files: [],
        createdAt: "2025-06-06T13:00:00Z"
      },
      {
        id: "a8",
        patientId: "p2",
        title: "Deep Cleaning",
        description: "Full mouth deep cleaning",
        comments: "Recommended by dentist",
        appointmentDate: "2025-08-05T11:00:00Z",
        status: "Scheduled",
        cost: 300,
        treatment: "",
        nextAppointment: "",
        files: [],
        createdAt: "2025-06-06T14:00:00Z"
      },
      {
        id: "a9",
        patientId: "p1",
        title: "Dental X-Ray",
        description: "Full mouth X-ray",
        comments: "Annual X-ray checkup",
        appointmentDate: "2025-08-10T09:30:00Z",
        status: "Scheduled",
        cost: 150,
        treatment: "",
        nextAppointment: "",
        files: [],
        createdAt: "2025-06-06T15:00:00Z"
      },
      {
        id: "a10",
        patientId: "p2",
        title: "Wisdom Tooth Extraction",
        description: "Remove impacted wisdom tooth",
        comments: "Local anesthesia required",
        appointmentDate: "2025-08-15T14:00:00Z",
        status: "Scheduled",
        cost: 400,
        treatment: "",
        nextAppointment: "",
        files: [],
        createdAt: "2025-06-06T16:00:00Z"
      },
      {
        id: "a11",
        patientId: "p1",
        title: "Braces Consultation",
        description: "Initial consultation for braces",
        comments: "Patient interested in clear aligners",
        appointmentDate: "2025-08-20T10:00:00Z",
        status: "Scheduled",
        cost: 100,
        treatment: "",
        nextAppointment: "",
        files: [],
        createdAt: "2025-06-06T17:00:00Z"
      },
      {
        id: "a12",
        patientId: "p2",
        title: "Gum Treatment",
        description: "Treatment for mild gingivitis",
        comments: "Preventive care needed",
        appointmentDate: "2025-08-25T13:00:00Z",
        status: "Scheduled",
        cost: 250,
        treatment: "",
        nextAppointment: "",
        files: [],
        createdAt: "2025-06-06T18:00:00Z"
      }
    ]
  };